export const isModuleEnabledForPlatform = (
  modules = [],
  moduleId,
  platform = null
) => {
  const module = modules.find((module) => module.moduleid === moduleId)
  if (!module) {
    return false
  }

  // If no platform specified, module cannot be verified as enabled
  if (!platform) {
    return false
  }

  // Check if the module is enabled for the current platform
  return module[platform] === 1
}
